//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const Styles = makeStyles((theme) => ({
    topGrid: {
        display: "flex",
        alignItems: "center",
        justifyContent: 'space-between'
    },
    searchInput: {
        width: 400,
        borderRadius: 20,
        "@media (max-width: 600px)": {
            width: "100%",
        },
    },
    selectInput: {
        margin: 'auto',
        borderRadius: 20,
        "@media (max-width: 600px)": {
            width: "100%",
        },
    },
    cancelBtn: {
        backgroundColor: "red",
        padding: "2px 12px",
        borderRadius: 20,
        color: "white",
        fontWeight: "bold",
        cursor: "pointer"
    },
    radioGroup: {
        margin: "8px 20px",
        display: 'flex',
        flexDirection: 'row'
    },
    radioButton: {
        padding: 3,
        color: "#233d75 !important"
    },
    // Dialog
    dialogParentDiv: {
        padding: 25,
    },
    parentText: {
        fontSize: 25,
    },

    proceedBtnGrid: {
        textAlign: "right",
    },
    proceedBtn: {
        color: "#fff",
        backgroundColor: "#305698",
        borderRadius: 10,
        fontSize: 20,
        textTransform: "capitalize",
        "&:hover": {
            backgroundColor: "#305698",
        },
    },
    noBtn: {
        color: "#305698",
        backgroundColor: "#fff",
        border: "2px solid #305698",
        borderRadius: 10,
        fontSize: 20,
        textTransform: "capitalize",
    },
    subParentText: {
        color: "#595959",
        fontSize: 20,
    },
    table: {
        minWidth: 750,
    },
    detailsPageHeader: {
        width: "100%",
        height: 50,
        backgroundColor: "#2F7CBD",
        marginTop: 10,
    },
    detailsPageHeaderGrid: {
        color: "#fff",
        fontSize: 20,
        display: "flex",
        alignItems: "center",
    },
    backArrowIcon: {
        fontSize: 22,
        margin: "10px 10px 10px 10px",
        cursor: "pointer",
    },
    detailsPageHeaderContent: {
        display: 'flex',
        justifyContent: 'space-between',
        flex: 0.9
    },
    tableContainer: {
        maxHeight: 310
    },
    tableHeading: {
        fontWeight: 'bold',
        height: 30
    },
    loadingDiv: {
        height: '25vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    loadingText: {
        textAlign: 'center'
    },
    exportBtn1: {
        color: "#fff",
        width: "120px",
        height: "35px",
        fontSize: "14px",
        cursor: "pointer",
        fontFamily: "segoe-ui",
        borderRadius: 5,
        backgroundColor: "#0a72ba",
        border: "none",
        // marginLeft:"38%",
    
        "@media (max-width: 600px)": {
          marginTop: "4rem",
        },
      },
      // CSVlink: {
      //   display: "none",
      // },
}))